import styled from 'styled-components';
import { Colors } from 'web-common/src/shared/styles';

type Pixels = number;

interface PixelProps {
  height?: Pixels;
  width?: Pixels;
}

interface HeadlineSpacerProps extends PixelProps {}

const getPxValueFromProps =
  (someKey: keyof PixelProps) =>
  (props: HeadlineSpacerProps): string =>
    `${props[someKey]}px`;

/**
 * @deprecated The shef-web design system is being retired. web-common has no
 *   counterpart yet — see the migration ticket before adding a new call site.
 * @see https://app.asana.com/0/0/1218340209776564
 */
export const HeadlineSpacer = styled.hr<HeadlineSpacerProps>`
  width: ${getPxValueFromProps('width')};
  border-width: ${getPxValueFromProps('height')};
  border-color: ${Colors.RADISH};
  border-style: solid;
  margin: 0;
  height: 0;
`;

HeadlineSpacer.defaultProps = {
  height: 3,
  width: 40,
};
